<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div class="form-title padding-title">
        {{ title }}
      </div>
      <div class="form-box-body">
        <div class="form-components scroll">
          <div
            class="form_combo_text"
            v-text="text"
          />
          <div
            class="form_label"
            v-text="'Tipo de producto (*)'"
          />
          <div
            id="productSelector"
            class="selectContainer"
          >
            <v-select
              v-model="dispositivo"
              class="style-chooser"
              :reduce="device => device.value"
              :options="options"
              label="name"
              :clearable="false"
            />
          </div>
          <div
            class="form_label"
            v-text="'Ingrese su nombre completo (*)'"
          />
          <div class="form__field">
            <label
              for="nombre"
            >
              <v-icon
                name="user"
                scale="1"
                style="margin: 1px 1px 0"
              />
            </label>
            <input
              id="nombre"
              ref="nombre"
              v-model="nombre"
              autocomplete="off"
              type="text"
              name="nombre"
              value=""
              placeholder="Nombre completo"
              required
              @focus="_clearError"
              @keyup.enter="focusTo('email')"
              @keypress="keyPressCheckSpecialChars($event, 'name')"
              @change="cleanSpecialChars('nombre', 'name')"
            >
          </div>

          <div
            class="form_label"
            v-text="'Ingrese su correo electrónico (*)'"
          />
          <div class="form__field">
            <label
              for="email"
            ><v-icon
              name="envelope"
              scale="1"
              style="margin-top: 2px"
            /></label>
            <input
              id="email"
              ref="email"
              v-model="email"
              class="email"
              autocomplete="off"
              type="text"
              name="email"
              value=""
              placeholder="usuario@dominio.com"
              required
              @focus="_clearError"
              @keyup.enter="focusTo('telefono')"
              @keypress="keyPressCheckSpecialChars($event, 'email')"
              @change="cleanSpecialChars('email', 'email')"
            >
          </div>

          <div
            class="form_label"
            v-text="'Ingrese su teléfono (*)'"
          />
          <div class="form__field">
            <label
              for="telefono"
            >
              <v-icon
                name="mobile-alt"
                scale="1"
                style="margin: 1px 2px 0 4px"
              />
            </label>
            <input
              id="telefono"
              ref="telefono"
              v-model="telefono"
              autocomplete="off"
              type="text"
              name="telefono"
              value=""
              placeholder="56 9 1234 5678"
              required
              @focus="_clearError"
              @keypress="keyPressCheckSpecialChars($event, 'phone')"
              @change="cleanSpecialChars('telefono', 'phone')"
            >
          </div>
          <div class="checkbox-div">
            <input
              id="policyCheckbox"
              v-model="policyCheck"
              type="checkbox"
              class="checkbox-form"
            >
            <label
              class="checkbox-label"
              for="policyCheckbox"
            >Aceptar <a
              href="https://www.tiendarealme.cl/policies/privacy-policy"
              target="_blank"
              class="a-link-policy"
            >políticas de privacidad</a></label>
          </div>
          <div class="checkbox-div">
            <input
              id="promotionCheckbox"
              v-model="newsletterCheck"
              type="checkbox"
              class="checkbox-form"
            >
            <label
              class="checkbox-label"
              for="promotionCheckbox"
            >Me gustaría recibir información sobre productos, servicios y promociones de realme</label>
          </div>
        </div>
      </div>
      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn btn_forms">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from '../../main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/shipping-fast'
import formUtils from '../../formUtils'
import utils from '../../utils'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  components: {
    'v-icon': Icon,
    'v-select': VueSelect
  },
  props: {},
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      nombre: '',
      telefono: '',
      email: '',
      comentario: '',
      dispositivo: '',
      policyCheck: false,
      newsletterCheck: false
    }
  },
  computed: {
    options () {
      return [
        {
          value: '',
          name: 'Seleccionar'
        },
        {
          value: 'celulares',
          name: 'Celulares'
        },
        {
          value: 'audifonos',
          name: 'Audifonos'
        }
      ]
    }
  },
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'RealmeProductExecutiveForm') return
      if (e.evento === 'newdata') {
        this.text = e.dato.text ? e.dato.text : ''
        this.title = e.dato.title ? e.dato.title : 'Formulario Experto de Productos'
        this.nombreOrigen = e.dato.fields.name ? e.dato.fields.name : ''
        this.emailOrigen = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoOrigen = e.dato.fields.phone
          ? e.dato.fields.phone
          : ''
        this.nombre = this.nombreOrigen
        this.email = this.emailOrigen
        this.telefono = this.telefonoOrigen
      }
    })
  },
  methods: {
    ...formUtils.formBase,
    _sentClick () {
      this.errormsg = ''
      if (!this.nombre || this.nombre === 'Visita' || this.nombre === '') {
        this.errormsg = 'Debes ingresar tu nombre'
        return
      }
      if (!this.dispositivo) {
        this.errormsg = 'Debes seleccionar el tipo de producto'
        return
      }
      if (!this.telefono) {
        this.errormsg = 'Debes ingresar el teléfono'
        return
      }
      if (!this.email) {
        this.errormsg = 'Debes ingresar email'
        return
      }
      if (!utils.isEmail(this.email)) {
        this.errormsg = 'Formato email incorrecto'
        return
      }
      if (this.policyCheck === false) {
        this.errormsg = 'Debe aceptar nuestras politicas de privacidad'
        return
      }
      const dataToSend = {
        form: 'RealmeProductExecutiveForm',
        evento: 'sentClick',
        data: {
          type: 'realme-form-product-executive-confirm',
          fields: {
            name: this.nombre,
            phone: this.telefono,
            email: this.email,
            device: this.dispositivo,
            policyChecked: this.policyCheck && this.policyCheck === true ? 'Sí' : 'No',
            newsletterChecked: this.newsletterCheck && this.policyCheck === true ? 'Sí' : 'No'
          }
        }
      }

      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'RealmeProductExecutiveForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
	margin-bottom: 7px;
}

.form-box-body {
	height: 335px;
}

</style>

<style scoped>
.style-chooser {
  --vs-controls-color: black;
  --vs-border-color: #ffc915;

  --vs-dropdown-bg: #ffc915;
  --vs-dropdown-color: black;
  --vs-dropdown-option-color: black;

  --vs-selected-bg: #664cc3;
  --vs-selected-color: black;

  --vs-search-input-color: #eeeeee;

  --vs-dropdown-option--active-bg: #23bad3;
  --vs-dropdown-option--active-color: #eeeeee;
}
</style>
